import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import tinycolor from 'tinycolor2';

import { RgbStringColorPicker } from 'react-colorful';

type TextToolsColorProps = {
  color: string;
  colorChange: (color: string) => void;
  colorChoose: (color: string) => void;
  colorCancel: (color: string) => void;
};

function TextToolbarSidebarColor(props: TextToolsColorProps) {
  const { color, colorChange, colorCancel, colorChoose } = props;

  const colorPickerElem = useRef<HTMLDivElement>(null);
  const thumbRef = useRef<HTMLButtonElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const restoreColor = useRef<string>(props.color);

  const [showPicker, setShowPicker] = useState(false);

  const rgbString = (c?: string) => tinycolor(c).toRgbString();

  function handleColorChange(c: string) {
    if (thumbRef.current) {
      thumbRef.current.style.backgroundColor = rgbString(c);
    }

    if (inputRef.current) {
      inputRef.current.value = rgbString(c);
    }

    colorChange(tinycolor(c).toHexString());
  }

  // Set it back to the previously used value
  function handleColorCancel() {
    if (restoreColor.current) {
      if (thumbRef.current) {
        thumbRef.current.style.backgroundColor = rgbString(restoreColor.current);
      }

      colorCancel(restoreColor.current);
    }
    setShowPicker(false);
  }

  function handleColorChoose() {
    if (inputRef.current) {
      const c = tinycolor(inputRef.current.value).toHexString();
      restoreColor.current = c;
      colorChoose(c);
    }

    setShowPicker(false);
  }

  return (
    <React.Fragment>
      <div className="texttools-item__text-node color-picker">
        <span className="pick-color">Text Color</span>
        <div className="color-picker-wrapper">
          <button
            ref={thumbRef}
            type="button"
            aria-label="Select text color"
            className="color-picker-trigger"
            style={{ backgroundColor: rgbString(color) }}
            onClick={() => setShowPicker(true)}
          />
          <input
            ref={inputRef}
            type="text"
            value={color}
            onChange={(e) => handleColorChange(e.target.value)}
            style={{ display: 'inline-block', width: '150px' }}
          />
        </div>
      </div>

      <div
        className="texttools__dropdown-items"
        ref={colorPickerElem}
        onClick={(e) => e.stopPropagation()}
      >
        {showPicker && (
          <div className="texttools__dropdown-item pick-color">
            <RgbStringColorPicker color={rgbString(color)} onChange={handleColorChange} />
            <div className="color-picker-button-container">
              <button
                type="button"
                className="color-picker-button cancel-button"
                onClick={handleColorCancel}
              >
                <FontAwesomeIcon icon="times" />
              </button>
              <button
                type="button"
                className="color-picker-button choose-button"
                onClick={handleColorChoose}
              >
                <FontAwesomeIcon icon="check" />
              </button>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default TextToolbarSidebarColor;
